import Loader from 'components/common/loader';
import { ReactNode, createContext } from 'react';
import { useState } from 'react';

export interface AppContextType {
  setLoader: (data: boolean) => void;
  loading: boolean;
}
export const AppContext = createContext<AppContextType>({ loading: false, setLoader: () => {} });

const AppContextProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const setLoader = (isLoading: boolean) => {
    setLoading(isLoading);
  };
  return (
    <AppContext.Provider value={{ loading, setLoader }}>
      {children}
      {loading ? <Loader /> : <></>}
    </AppContext.Provider>
  );
};
export default AppContextProvider;
